export default "__VITE_ASSET__bW$1BY$u__"